import React, { PureComponent } from "react";
import axios from "axios";
import { server, config, checkAccess } from "../env";
import Header from "../components/Header";
import TopCard from "./DashboardComponents/StatsTopCard";
import Announcement from "../components/Announcement";

export default class Dashboard extends PureComponent {
  state = {
    data: {},
  };

  componentDidMount = () => {
    document.title = "Dashboard - Proxies.gg";
    this.readDataStats();
  };

  readDataStats = async () => {
    await axios
      .get(server + "/v1/user/dashboard-stats", config)
      .then((rsp) => {
        this.setState({
          data: rsp.data.payload,
        });
      })
      .catch((err) => {
        checkAccess(err);
      });
  };

  render() {
    const { data } = this.state;

    return (
      <div className="main-content">
        <Announcement />
        <Header pretitle="Overview" title="Dashboard" />

        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <TopCard
                  title="Total Plan Purchased"
                  value={data.totalPlanPurchased || 0}
                  icon="fe-box"
                  col="col-12 col-lg-6"
                />

                <TopCard
                  title="Total Amount moneySpent"
                  value={
                    data.moneySpent
                      ? data.moneySpent.toFixed(2) + " €"
                      : 0 + " €"
                  }
                  icon="fe-box"
                  col="col-12 col-lg-6"
                />
                <TopCard
                  title="Pending Activations"
                  value={data.totalPendingActivation || "N/A"}
                  icon="fe-box"
                  col="col-12 col-lg-6"
                />

                <TopCard
                  title="Referral Points"
                  value={data.referral_points}
                  icon="fe-zap"
                  col="col-12 col-lg-6"
                />
                <TopCard
                  title="Referral Code"
                  value={data.referral_code}
                  icon="fe-share-2"
                  col="col-12 col-lg-6"
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="card">
                <div className="card-body">
                  <div className="row justify-content-center align-items-center">
                    <img
                      src="/assets/img/avatars/user.png"
                      className="avatar-img rounded-circle"
                      alt="..."
                      style={{ width: "200px" }}
                    />
                  </div>
                  <div className="text-center">
                    <h2>
                      <b>{data.username ? data.username.toUpperCase() : ""}</b>
                    </h2>
                  </div>
                </div>

                <ul class="list-group">
                  <li class="list-group-item">
                    <div className="row justify-content-between">
                      <div className="col-auto">Username</div>
                      <div className="col-auto">{data.username}</div>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div className="row justify-content-between">
                      <div className="col-auto">Email</div>
                      <div className="col-auto">{data.email}</div>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div className="row justify-content-between">
                      <div className="col-auto">Is 2 FA Enable</div>
                      <div className="col-auto">
                        {data.is_2fa_enabled ? "Yes" : "No"}
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div className="row justify-content-between">
                      <div className="col-auto">Date Joined</div>
                      <div className="col-auto">
                        {new Date(data.joined).toDateString()}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
